import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import {RegistriesService} from '../../../service';
import {ActivatedRoute} from '@angular/router';
import {MvkDecisionDetails} from "../../../model";
import {Utils} from "@amlCore/utils";
import {Subscription} from "rxjs";
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-registry-mvk-form',
  templateUrl: './mvk.component.html'
})
export class MvkComponent implements OnInit, OnDestroy {
  @Output() startLoading: any = new EventEmitter<boolean>();
  @Output() finishLoading: any = new EventEmitter<boolean>();
  @Input() decisionId = null;
  @Input() subjectId = null;
  @Input() isModal = false;

  item: MvkDecisionDetails;
  mvkSub: Subscription;
  constructor(private regSrv: RegistriesService,
              private route: ActivatedRoute,
              private _activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
    if (this.decisionId && this.subjectId) {
      this.startLoading.emit(true);
      // TODO этот метод Deprecated
      this.startLoading.complete();
      this.loadSubject(this.decisionId, this.subjectId);
    } else {
      this.route.params.subscribe(params => {
        Utils.scrollTopSmooth();
        this.decisionId = params.id;
        this.subjectId = params.subjectId;
        this.loadSubject(this.decisionId, this.subjectId);
      });
    }
  }

  loadSubject(decisionId, subjectId): void {
    this.mvkSub = this.regSrv.getMvkById(decisionId, subjectId).subscribe(data => {
      this.item = data;
      this.finishLoading.emit(false);
      // TODO этот метод Deprecated
      this.finishLoading.complete();
    }, (error) => { console.error(error) });
  }

  closeModal() {
    this._activeModal.dismiss(false);
  }

  ngOnDestroy(): void {
    this.mvkSub.unsubscribe();
  }
}
